/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Button, FlexContainer, H2, Text } from "@carrotfertility/carotene"
import { CircleImage } from "../views/atoms/images/CircleImage"
import { FormattedMessage } from "react-intl"

type PersonalEmailActionTakenModalProps = {
  header: string
  body: string
  image: string
  onClose: () => void
}

export default function PersonalEmailActionTaken({
  header,
  body,
  image,
  onClose
}: PersonalEmailActionTakenModalProps): JSX.Element {
  return (
    <>
      <FlexContainer paddingTopBottom={"32px"} alignItems={"center"} direction={"column"}>
        <CircleImage size={160} iconName={image} />
      </FlexContainer>

      <FlexContainer stack={"large"} paddingLeftRight={"48px"} alignItems={"center"} direction={"column"}>
        <H2 stack={"tiny"}>{header}</H2>
        <Text align={"center"}>{body}</Text>
      </FlexContainer>

      <FlexContainer stack={"medium"} alignItems={"center"} direction={"column"}>
        <Button onClick={onClose}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </FlexContainer>
    </>
  )
}
